/* ==========================================================================
   <simple-product-card>
   - the size select updates the full-image PDP link (it does NOT add to cart)
   - the covering link (and title link) point at the PDP for the selected size
     and the product's own colour
   - an optional Add to Bag button adds the current variant via cart/add.js and
     opens the cart drawer (cart:build / cart:open events, as the theme expects)
   ========================================================================== */
(function () {
  class SimpleProductCard extends HTMLElement {
    connectedCallback() {
      this.links = [this.querySelector('.spc__media'), this.querySelector('.spc__title')].filter(Boolean);
      this.select = this.querySelector('.spc__size');
      this.atc = this.querySelector('.spc__atc');

      this.data = { sizes: {} };
      const dataEl = this.querySelector('.spc__data');
      if (dataEl) {
        try { this.data = JSON.parse(dataEl.textContent); } catch (e) { /* keep defaults */ }
      }
      this.currentId = this.data.default;

      if (this.select) this.select.addEventListener('change', () => this._updateLink());
      if (this.atc) this.atc.addEventListener('click', () => this._addToCart());
    }

    _updateLink() {
      const size = this.select.value;
      const id = this.data.sizes && this.data.sizes[size];
      if (!id) return;
      this.currentId = id;
      const href = this.data.url + '?variant=' + id;
      this.links.forEach((link) => link.setAttribute('href', href));
    }

    async _addToCart() {
      if (!this.currentId) return;
      const button = this.atc;
      const original = button.textContent;
      button.disabled = true;
      button.textContent = 'Adding…';

      const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      try {
        const response = await fetch(root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: this.currentId, quantity: 1 }] }),
        });
        const data = await response.json();
        if (response.ok && !data.status) {
          button.textContent = 'Added ✓';
          document.dispatchEvent(new CustomEvent('cart:build'));
          document.dispatchEvent(new CustomEvent('cart:open'));
        } else {
          button.textContent = original;
        }
      } catch (e) {
        button.textContent = original;
      } finally {
        setTimeout(() => {
          button.disabled = false;
          button.textContent = original;
        }, 1500);
      }
    }
  }

  if (!customElements.get('simple-product-card')) {
    customElements.define('simple-product-card', SimpleProductCard);
  }
})();
